module.exports = __webpack_public_path__ + "img/pic_logo.17036490.png";